var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "availability" } }, [
    _c("div", { staticClass: "material-icons time-icon" }, [
      _vm._v("access_time"),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("span", { staticClass: "time-label" }, [
          _vm._v(_vm._s(_vm.$t("calendar.generalAvailability"))),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "time-sub-label" }, [
          _vm._v(_vm._s(_vm.$t("calendar.generalAvailabilityDesc"))),
        ]),
        _vm._v(" "),
        _vm._l(_vm.availability.rules, function (rule, index) {
          return _c("div", { staticClass: "ruleItem" }, [
            _c("div", { staticClass: "options" }, [
              _c(
                "div",
                { staticClass: "days" },
                [
                  _c(
                    "a-select",
                    {
                      staticClass: "select-item",
                      attrs: {
                        "show-search": "",
                        placeholder: _vm.$t("message.selectDayys"),
                        value: _vm.dayLabels[index],
                      },
                      on: {
                        change: function ($event) {
                          return _vm.updateDays($event, index)
                        },
                      },
                    },
                    _vm._l(_vm.days, function (day, i) {
                      return _c(
                        "a-select-option",
                        {
                          key: i,
                          attrs: { value: _vm.daysHashcode(day.value) },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(day.label[_vm.$i18n.locale]) +
                              "\n                        "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "option" },
                [
                  _c(
                    "a-select",
                    {
                      staticClass: "select-item",
                      attrs: {
                        "show-search": "",
                        placeholder: _vm.$t("message.selectStartHour"),
                      },
                      model: {
                        value: rule.from,
                        callback: function ($$v) {
                          _vm.$set(rule, "from", $$v)
                        },
                        expression: "rule.from",
                      },
                    },
                    _vm._l(_vm.hours, function (hour, i) {
                      return _c(
                        "a-select-option",
                        { key: i, attrs: { value: hour } },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(hour) +
                              "\n                        "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "option" },
                [
                  _c(
                    "a-select",
                    {
                      staticClass: "select-item",
                      attrs: {
                        "show-search": "",
                        placeholder: _vm.$t("message.selectEndHour"),
                      },
                      model: {
                        value: rule.to,
                        callback: function ($$v) {
                          _vm.$set(rule, "to", $$v)
                        },
                        expression: "rule.to",
                      },
                    },
                    _vm._l(_vm.hours, function (hour, i) {
                      return _c(
                        "a-select-option",
                        { key: i, attrs: { value: hour } },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(hour) +
                              "\n                        "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.availability.rules.length > 1
                ? _c(
                    "div",
                    {
                      staticClass: "material-icons delete-icon",
                      on: {
                        click: function ($event) {
                          return _vm.removeRule(index)
                        },
                      },
                    },
                    [_vm._v("\n                    close\n                ")]
                  )
                : _vm._e(),
            ]),
          ])
        }),
        _vm._v(" "),
        _c(
          "SupsisButton",
          {
            staticClass: "add-new-availability",
            class: _vm.getDisabled() ? "disabled" : "",
            on: {
              click: function ($event) {
                return _vm.addNewAvailability()
              },
            },
          },
          [_vm._v("+ " + _vm._s(_vm.$t("task.add")) + "\n        ")]
        ),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticClass: "timezone-select",
            attrs: { "show-search": "" },
            model: {
              value: _vm.availability.timezone,
              callback: function ($$v) {
                _vm.$set(_vm.availability, "timezone", $$v)
              },
              expression: "availability.timezone",
            },
          },
          _vm._l(_vm.timezones, function (value, index) {
            return _c(
              "a-select-option",
              { key: index, attrs: { value: value } },
              [_vm._v("\n                " + _vm._s(value) + "\n            ")]
            )
          }),
          1
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }